import { parseQuestionText } from './parseQuestionText';

const HEADERS = {
  sv: /🇸🇪|^(svenska|swedish|svensk|السويدية)$/i,
  ar: /🇸🇦|🇸🇾|🇮🇶|^(العربية|عربي|arabic|arabiska)$/i,
  en: /🇬🇧|🇺🇸|^(english|engelska|engelsk|الإنجليزية)$/i,
  tr: /🇹🇷|^(türkçe|turkce|turkish|turkiska|التركية)$/i,
  fa: /🇮🇷|🇦🇫|^(فارسی|دری|persian|farsi|dari|persiska|الفارسية)$/i,
  so: /🇸🇴|^(soomaali|somali|somaliska|الصومالية)$/i,
  pl: /🇵🇱|^(polski|polish|polska|البولندية)$/i,
  es: /🇪🇸|^(español|espanol|spanish|spanska|الإسبانية)$/i,
  de: /🇩🇪|^(deutsch|german|tyska|الألمانية)$/i,
};
const AR_ROOTS = {
  sv: /^سويد/, ar: /^عرب/, en: /^(انجليز|انكليز|انقليز|انكلش|انجلش|انجليش|انكليش)/, tr: /^ترك/,
  fa: /^(فارس|دري|افغان)/, so: /^صومال/, pl: /^(بولند|بولون)/, es: /^(اسبان|سبان)/, de: /^(الماني|المان|المانيه)/,
};
const arNorm = (t) => t.replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/^(اللغه\s+|لغه\s+)/, '').replace(/^ال(?!مان)/, '').trim();
const arHeader = (t) => { const n = arNorm(t); return n.length <= 15 ? Object.keys(AR_ROOTS).find((k) => AR_ROOTS[k].test(n)) || null : null; };

const LABELS = [
  ['sv', /^(fråga|frågan)\s*[:：]/i], ['ar', /^السؤال\s*[:：]/], ['en', /^question\s*[:：]/i], ['tr', /^soru\s*[:：]/i],
  ['fa', /^(سؤال|سوال)\s*[:：]/], ['so', /^su['’]?aal\s*[:：]/i], ['pl', /^pytanie\s*[:：]/i], ['es', /^pregunta\s*[:：]/i], ['de', /^frage\s*[:：]/i],
];

const strip = (l) => l.replace(/\*\*|__|`|#/g, '').trim();
const headerLang = (line) => {
  const t = strip(line);
  if (t.length > 40) return null;
  const plain = t.replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '').replace(/[:：\-–]/g, '').trim();
  return Object.keys(HEADERS).find((k) => HEADERS[k].test(t.match(/[\u{1F1E6}-\u{1F1FF}]/u) ? t : plain)) || arHeader(plain);
};

const splitBy = (lines, detect) => {
  const out = {};
  let cur = null;
  for (const line of lines) {
    const lang = detect(line);
    if (lang && !out[lang]) { cur = lang; out[lang] = []; if (detect === labelLang) out[lang].push(line); continue; }
    if (cur) out[cur].push(line);
  }
  return out;
};
function labelLang(line) { const t = strip(line); return (LABELS.find(([, re]) => re.test(t)) || [null])[0]; }

export const splitAllLanguages = (text) => {
  const lines = text.split(/\r?\n/);
  let groups = splitBy(lines, headerLang);
  if (Object.keys(groups).length < 2) groups = splitBy(lines, labelLang);
  return Object.fromEntries(Object.entries(groups).map(([k, v]) => [k, { raw: v.join('\n').trim(), ...parseQuestionText(v.join('\n')) }]));
};
